// eslint-disable-next-line hubspot-dev/no-confusing-browser-globals
export const getLocation = () => location;